import React, { useEffect, useState } from "react";
import PartnerListCard from "../../components/PartnerListCard/PartnerListCard";
import { useNavigate } from "react-router-dom";
import { axiosFunction } from "../../axiosFunction";
import { smaartCardUrl } from "../../constant";
import { useSelector } from "react-redux";
import Footer from "../../components/Footer/Footer";
import Header from "../../components/Header/Header";
import { PartnerListingPageContainer } from "../PartnerListingPage/PartnerListingPageContainer";

const PartnerFavouritesPage = () => {
  const navigate = useNavigate();
  const userData = useSelector((state) => state.userData);

  const [partnerList, setPartnerList] = useState([]);

  const handleCardClick = (partnerObj) => {
    const partnerName = partnerObj?.partnerName
      .split(" ")
      .join("_")
      .toLowerCase();
    navigate(`/partner/${partnerName}/${partnerObj?.partnerId}`);
  };

  const getFavouritePartners = async () => {
    const res = await axiosFunction(
      `${smaartCardUrl}/api/v1/dfordr/user/getFavouritePartners?userId=${userData.patientId}`,
      "GET",
      null
    );

    if (res?.data?.status) {
      setPartnerList(res?.data?.response);
    } else {
      setPartnerList([]);
    }
  };

  useEffect(() => {
    getFavouritePartners();
  }, []);

  return (
    <PartnerListingPageContainer>
      <Header />
      <div className="allContent">
        <PartnerListCard
          partners={partnerList}
          handleCardClick={handleCardClick}
          offers={false}
          getFavouritePartners={getFavouritePartners}
        />
      </div>
      <Footer />
    </PartnerListingPageContainer>
  );
};

export default PartnerFavouritesPage;
